import React, { useContext } from "react";
import { useTextDomainContext } from "@/app/providers";
import { usePageTitle } from "@/hooks";

export const MeterData = () => {
  const { TextDomainContext } = useTextDomainContext();
  const { gettext } = useContext(TextDomainContext);

  usePageTitle(gettext("Meter Data"));

  return (
    <div>
      <h2>{gettext("Meter Data")}</h2>
      <p>{gettext("This page is under construction.")}</p>
    </div>
  );
};
